module.exports = __webpack_public_path__ + "img/chike.936a613.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/chike.png
// module id = Fm43
// module chunks = 0